<app-loader></app-loader>
<div id="wrapper">
  <app-sidebar></app-sidebar>
  <app-header style="width: 100%;"></app-header>
  <!-- <div class="ne"> -->
  <div >
    <router-outlet></router-outlet>

  </div>
  <!-- (menutitle)="setmenutitle($event)" (mainmenutitle)="setmainmenutitle($event)" -->
</div>